import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [

      { path: '/', component: () => import('@/layout'),
        children: [
          { path: '/', component: () => import('@/components/home') },
          { path: '/lista-espera', component: () => import('@/components/lista-espera') },
          { path: '/inscricao', redirect: '/' },

          // { path: '/inscricao', component: () => import('@/components/inscricao') },
          // { path: '/inscricao/status/:cod', component: () => import('@/components/inscricao/status') },
          // { path: '/consulta-inscricao', component: () => import('@/components/consulta-inscricao') },
          // { path: '/cancela-inscricao', component: () => import('@/components/cancela-inscricao') },

          { path: '/inscricao/status/:cod', component: () => import('@/components/inscricao-novatos/status') },
          // { path: '/inscricao', component: () => import('@/components/inscricao-novatos') },
          { path: '/consulta-inscricao', component: () => import('@/components/consulta-inscricao-novatos') },
          { path: '/cancela-inscricao', component: () => import('@/components/cancela-inscricao-novatos') },

          // { path: '/inscricao', component: () => import('@/components/inscricao-pcd') },
          // { path: '/inscricao/status/:cod', component: () => import('@/components/inscricao-pcd/status') },
          // { path: '/consulta-inscricao', component: () => import('@/components/consulta-inscricao-pcd') },
          // { path: '/cancela-inscricao', component: () => import('@/components/cancela-inscricao-pcd') },

          { path: '/calendario', component: () => import('@/components/calendario') },
          { path: '/faq', component: () => import('@/components/faq') },
          { path: '/contato', component: () => import('@/components/contato') },
          { path: '/info-matricula', component: () => import('@/components/info-matricula') },
        ],
      }
  ]
})

export default router
